// RU: ожидание набора анимаций, которое forceStop может оборвать. Пропускается всегда ТЕКУЩИЙ
//     запуск: колбэк одного запуска часто сам начинает следующий (раскрытие wild → вспышка
//     выигрыша), поэтому ссылку на свой резолвер запуск снимает ДО колбэка и только если она
//     всё ещё его. Прежде её обнуляли после колбэка — и затирали резолвер только что начатой
//     вспышки: forceStop не мог её «поторопить».
export const skippablePromise = () => {
  let skipCurrentRun = null;

  const runPromise = async (promises, callBack) => {
    let skipThisRun = null;
    const skipped = new Promise((resolve) => {
      skipThisRun = resolve;
    });
    skipCurrentRun = skipThisRun;
    await Promise.race([Promise.all(promises), skipped]);
    if (skipCurrentRun === skipThisRun) skipCurrentRun = null;
    callBack();
  };

  const skipPromise = () => {
    if (skipCurrentRun) skipCurrentRun();
  };

  return { runPromise, skipPromise };
};
